import getLocalString from "constants/Localization";
import { useUpdateJobPhaseChecklistItemsMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateJobPhaseChecklistItems() {
  const [mutation, { loading, data, error }] = useUpdateJobPhaseChecklistItemsMutation({
    refetchQueries: ["getJobPhase", "customGetJobPhase"],
  });

  const [updateJobPhaseChecklistItems, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateJobPhaseChecklistItems",
    },
    {
      successMessage: getLocalString("jobPhases.update-checklist-items-success"),
      failureMessage: getLocalString("jobPhases.update-checklist-items-failure"),
    }
  );

  return [updateJobPhaseChecklistItems, context] as const;
}
 